import React, { useState } from 'react';
import { Form, Input, Button, Card, Alert, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/authContext';

const Signin = () => {
  const navigate = useNavigate();
  const { login, resetPassword } = useAuth();
  
  const [status, setStatus] = useState({
    loading: false,
    error: '',
    success: ''
  });

  const [isForgotPassword, setIsForgotPassword] = useState(false); // To toggle between signin and forgot password
  const [email, setEmail] = useState('');

  const onFinish = async (values) => {
    setStatus({ loading: true, error: '', success: '' });

    if (isForgotPassword) {
      try {
        await resetPassword(values.email); // Your method to send reset password email
        setStatus({
          loading: false,
          success: 'Password reset link sent to your email.',
        });
      } catch (error) {
        setStatus({
          loading: false,
          error: error.message || 'Something went wrong, please try again later',
        });
      }
    } else {
      try {
        await login(values.email, values.password);
        navigate('/');
      } catch (error) {
        setStatus({
          loading: false,
          error: error.code === 'auth/wrong-password'
            ? 'Incorrect Password'
            : error.code === 'auth/user-not-found'
            ? 'User not found, please contact support'
            : 'Something went wrong, please try again later',
        });
      }
    }
  };

  return (
    <div className="h-screen flex justify-center items-center bg-gradient-to-r from-blue-500 to-indigo-500">
      <Card className="w-full sm:w-96 bg-white p-8 rounded-lg shadow-lg" bordered={false}>
        <div className="text-center mb-6">
          <img src="https://5.imimg.com/data5/SELLER/Logo/2024/10/459711976/MT/YZ/YE/160654475/printverse-logo-120x120.jpg" alt="Company Logo" className="w-24 mx-auto mb-4" />
          <h2 className="text-2xl font-bold text-gray-700">{isForgotPassword ? 'Reset Password' : 'Sign In'}</h2>
        </div>

        {status.error && (
          <Alert message={status.error} type="error" showIcon className="mb-4" />
        )}

        {status.success && (
          <Alert message={status.success} type="success" showIcon className="mb-4" />
        )}

        <Form onFinish={onFinish} layout="vertical">
          {isForgotPassword ? (
            <Form.Item
              name="email"
              label="Email"
              rules={[{ required: true, message: 'Please enter your email' }]}
            >
              <Input
                className="text-sm p-4 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500"
                placeholder="Enter your email"
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Item>
          ) : (
            <>
              <Form.Item
                name="email"
                label="Email"
                rules={[{ required: true, message: 'Please enter your email' }]}
              >
                <Input
                  className="text-sm p-4 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500"
                  placeholder="Email"
                  prefix={<i className="fas fa-envelope text-gray-400"></i>}
                />
              </Form.Item>

              <Form.Item
                name="password"
                label="Password"
                rules={[{ required: true, message: 'Please enter your password' }]}
              >
                <Input.Password
                  className="text-sm p-4 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500"
                  placeholder="Password"
                  prefix={<i className="fas fa-lock text-gray-400"></i>}
                />
              </Form.Item>
            </>
          )}

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={status.loading}
              block
              className="w-full text-sm text-white rounded-lg bg-blue-600 hover:bg-blue-700"
            >
              {isForgotPassword ? 'Send Reset Link' : 'Log In'}
            </Button>
          </Form.Item>
        </Form>

        <div className="text-center mt-4">
          <Space>
            {isForgotPassword ? (
              <>
                <a
                  href="#"
                  className="text-sm text-blue-600 hover:underline"
                  onClick={() => setIsForgotPassword(false)}
                >
                  Back to Login
                </a>
              </>
            ) : (
              <>
                <a
                  href="#"
                  className="text-sm text-blue-600 hover:underline"
                  onClick={() => setIsForgotPassword(true)}
                >
                  Forgot Password?
                </a>
                {/* <span className="text-sm text-gray-500">or</span>
                <a href="#" className="text-sm text-blue-600 hover:underline">Create an Account</a> */}
              </>
            )}
          </Space>
        </div>
      </Card>
    </div>
  );
};

export default Signin;
